import controller from './pay-by-card.controller';

export default {
  controller,
  template: require('./pay-by-card.html')
};



// WEBPACK FOOTER //
// src/app/buy/pay-by-card/pay-by-card.component.ts